import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';

export const isHomeCrossAppCreateEnabled = (): boolean =>
	isFeatureEnabled('home', 'home-cross-app-create');

export const isHomeDashboardExperienceEnabled = (): boolean =>
	isFeatureEnabled('home', 'home-dashboard-experience');

export const isSlackMsTeamsEnabled = (): boolean =>
	isFeatureEnabled('home', 'home-ms-teams-and-slack-integration');

export const isCollaborationGraphEnabled = (): boolean =>
	isFeatureEnabled('teamwork-graph-platform', 'collaboration-graph');

export const isHomeWhereYouWorkEnabled = (): boolean =>
	isFeatureEnabled('home', 'home-where-you-work');

/**
 * This check indicates whether Rovo is even possible in the current environment block. It does not indicate whether
 * the user has access to Rovo, or if the current instance has Rovo provisioned/connected.
 */
export const isRovoAvailable = (): boolean => isFeatureEnabled('rovo', 'rovo-ai-app-availability');

export const isCypherFlockAvailable = (): boolean =>
	isFeatureEnabled('teamwork-graph-platform', 'flock');
